import * as R from 'ramda';
import {
  categoryDisplay,
  dimensionValueDisplayAt,
  getTimePeriodDimension,
} from '../dimension-utils';
import { getFormatedObservation } from '../observation-formater';

const getDimensionValues = (
  splitObservationKey,
  dimensions,
  dimensionsWithValuesIndexedById,
  rejectedId,
  display,
) =>
  R.addIndex(R.reduce)(
    (acc, dimensionValueIndex, dimensionIndex) => {
      const dimension = R.nth(dimensionIndex, dimensions) || {};
      if (R.has(dimension.id, dimensionsWithValuesIndexedById) && dimension.id !== rejectedId) {
        const dimensionValue = R.pathOr({}, ['values', dimensionValueIndex], dimension);
        return R.set(
          R.lensPath([dimensionValue.id, 'name']),
          dimensionValueDisplayAt(dimension, dimensionValueIndex, display),
          acc,
        );
      }
      return acc;
    },
    {},
    splitObservationKey,
  );

const series = (
  observations,
  dimensions,
  dimensionsWithValuesIndexedById,
  timePeriodDimensionIndex,
  display,
  formaterAttrs,
) => {
  const rawSeries = R.reduce(
    (acc, k) => {
      const o = observations[k];
      const oDimensionValuesIndexes = R.split(':', k);

      const timePeriodDimension = R.nth(timePeriodDimensionIndex, dimensions);
      const timePeriodDimensionValueIndex = R.nth(
        timePeriodDimensionIndex,
        oDimensionValuesIndexes,
      );
      const timePeriod = R.path(['values', timePeriodDimensionValueIndex], timePeriodDimension);

      const datapoint = {
        x: timePeriod.start,
        y: R.head(o),
        timeLabel: timePeriod.name,
        formatedValue: getFormatedObservation(o, formaterAttrs),
        dimensionValues: getDimensionValues(
          oDimensionValuesIndexes,
          dimensions,
          dimensionsWithValuesIndexedById,
          timePeriodDimension.id,
          display,
        ),
      };

      const category = categoryDisplay(
        oDimensionValuesIndexes,
        dimensions,
        dimensionsWithValuesIndexedById,
        timePeriodDimension.id,
        display,
      );
      let key = categoryDisplay(
        oDimensionValuesIndexes,
        dimensions,
        dimensionsWithValuesIndexedById,
        timePeriodDimension.id,
        'code',
      );
      if (R.isNil(key) || R.isEmpty(key)) {
        key = 'uniq-dp';
      }
      const serieIndex = R.findIndex(serie => serie.key === key, acc);

      if (serieIndex !== -1)
        return R.over(R.lensPath([serieIndex, 'datapoints']), R.append(datapoint), acc);

      return R.append({ datapoints: [datapoint], category, key }, acc);
    },
    [],
    R.keys(observations),
  );
  return R.map(
    serie => ({ ...serie, datapoints: R.sortBy(R.prop('x'), serie.datapoints) }),
    rawSeries,
  );
};

export default (
  { observations, dimensions },
  dimensionsWithValuesIndexedById,
  display,
  formaterAttrs,
) => {
  const timePeriodDimension = getTimePeriodDimension(dimensions);
  const timePeriodDimensionIndex = timePeriodDimension ? timePeriodDimension.__index : -1;
  const timePeriodDimensionHasManyPeriods = !R.has(
    R.prop('id', timePeriodDimension),
    dimensionsWithValuesIndexedById,
  );
  if (
    !timePeriodDimensionIndex ||
    timePeriodDimensionIndex === -1 ||
    timePeriodDimensionHasManyPeriods
  )
    return [];

  return series(
    observations,
    dimensions,
    dimensionsWithValuesIndexedById,
    timePeriodDimensionIndex,
    display,
    formaterAttrs,
  );
};
